import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=c65b5ae2&scoped=true"
import script from "./PlanDetails.vue?vue&type=script&lang=js"
export * from "./PlanDetails.vue?vue&type=script&lang=js"
import style0 from "./PlanDetails.vue?vue&type=style&index=0&id=c65b5ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65b5ae2",
  null
  
)

export default component.exports